import { apiClient } from '@/services/base'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { ITransferInStatementSyncRequest } from './interfaces/request'
import { ITransferInStatementSyncResponse } from './interfaces/response'

export const TransferInStatementSyncService =
  async (): Promise<ITransferInStatementSyncResponse> => {
    const response = await apiClient.post(
      '/api/account/transferInStatementSync',
    )
    return response
  }

export const useTransferInStatementSyncService = (
  isAuthenticated: boolean,
): UseQueryResult<ITransferInStatementSyncResponse, Error> => {
  return useQuery<ITransferInStatementSyncResponse>({
    queryKey: ['transferInStatementSync'],
    queryFn: () => TransferInStatementSyncService(),
    refetchInterval: isAuthenticated ? 30000 : false, // 30 segundos se autenticado
    enabled: isAuthenticated,
    retry: false, // Não tenta novamente em caso de erro
    refetchOnWindowFocus: false, // Não refaz ao focar na janela
    refetchOnMount: true, // Executa imediatamente quando montado
  })
}

export type {
  ITransferInStatementSyncRequest,
  ITransferInStatementSyncResponse,
}
